import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from './investors-header.module.scss';
import AnghamiImage from '@components/anghami-image';
import { environment } from '@environment';

export default function InvestorsHeader() {
	const { t } = useTranslation();

	return (
		<div className={styles.header_wrapper}>
			<div className={styles.image_container}>
				<div className={styles.desktop_image_wrapper}>
					<AnghamiImage
						priority
						src={environment.new_web_cdn_url + '/new/investors/investors-desktop.png'}
						alt="Investor Relations - Nasdaq"
						width={1920}
						height={740}
						style={{ width: '100%', height: 'auto' }}
					/>
				</div>
				<div className={styles.mobile_image_wrapper}>
					<AnghamiImage
						priority
						src={environment.new_web_cdn_url + '/new/investors/investors-mobile.png'}
						alt="Investor Relations - Nasdaq"
						width={1920}
						height={740}
						style={{ width: '100%', height: 'auto' }}
					/>
				</div>
				<div className={styles.title_container}>
					<h1 className={styles.main_title}>{t('IR_landing_title')}</h1>
				</div>
			</div>
		</div>
	);
}
